import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { t } from "../../../../services";
import { firmwareDeviceTypes, strCode } from "../../../../consts";

import { DropdownInput, FlexContainers, WrapperContainer } from "../../../../components";

const Device = ({
  isLoading,
  fwuVersion,
  setFwuVersion,
  selectedModelOptionId,
  setSelectedModelOptionId,
  selectedTypeOptionId,
  setSelectedTypeOptionId
}) => {
  const deviceTypeOptions = useMemo(() => {
    return (
      firmwareDeviceTypes
        .find((type) => type.id === selectedModelOptionId)
        ?.types?.map((type) => {
          return {
            id: type,
            value: type.charAt(0).toUpperCase() + type.slice(1)
          };
        }) || []
    );
  }, [selectedModelOptionId]);

  useEffect(() => {
    if (fwuVersion) {
      const selectedModel = firmwareDeviceTypes.find(
        (type) => type.patchVersion === `${fwuVersion.fwuVersion.patch}`
      );

      if (selectedModel) {
        setSelectedModelOptionId(selectedModel.id);
      }
    }
  }, [fwuVersion?.fwuVersion?.patch]);

  useEffect(() => {
    if (selectedModelOptionId) {
      const selectedModel = firmwareDeviceTypes.find((type) => type.id === selectedModelOptionId);

      setFwuVersion((prev) => {
        return {
          ...prev,
          fwuVersion: { ...prev.fwuVersion, patch: Number(selectedModel.patchVersion) }
        };
      });
    }
  }, [selectedModelOptionId]);

  useEffect(() => {
    if (selectedModelOptionId && selectedTypeOptionId) {
      const deviceModel = firmwareDeviceTypes.find((type) => type.id === selectedModelOptionId);

      const deviceType = deviceTypeOptions.find((type) => type.id === selectedTypeOptionId);

      setFwuVersion((prev) => {
        return { ...prev, deviceType: deviceType.value, model: deviceModel.value };
      });
    }
  }, [selectedModelOptionId, selectedTypeOptionId]);

  return (
    <WrapperContainer Container={FlexContainers.FlexRowBetween} gap={8} width={"100%"}>
      <DropdownInput
        id="firmware-device-model-select"
        title={t(strCode.DEVICE_MODEL)}
        options={firmwareDeviceTypes}
        placeholder={t(strCode.SELECT_PLACEHOLDER_2)}
        selectedOption={firmwareDeviceTypes.find((type) => type.id === selectedModelOptionId)}
        onSelectOption={(option) => setSelectedModelOptionId(option)}
        disabled={isLoading}
      />

      <DropdownInput
        id="firmware-device-type-select"
        title={t(strCode.DEVICE_TYPE)}
        options={deviceTypeOptions}
        placeholder={t(strCode.SELECT_PLACEHOLDER_2)}
        selectedOption={deviceTypeOptions.find((type) => type.id === selectedTypeOptionId)}
        onSelectOption={(option) => setSelectedTypeOptionId(option)}
        disabled={!selectedModelOptionId || isLoading}
      />
    </WrapperContainer>
  );
};

Device.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  fwuVersion: PropTypes.shape({
    fwuVersion: PropTypes.object,
    deviceType: PropTypes.string,
    model: PropTypes.string
  }).isRequired,
  setFwuVersion: PropTypes.func.isRequired,
  selectedModelOptionId: PropTypes.string.isRequired,
  setSelectedModelOptionId: PropTypes.func.isRequired,
  selectedTypeOptionId: PropTypes.string.isRequired,
  setSelectedTypeOptionId: PropTypes.func.isRequired
};

export default Device;
